import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'geo_zones',
  title: 'Геозоны',
  apiType: apiTypes.REPORT_API,
  elemsOnPage: 100,
  connections: {
  },
  fields: [
    {
      name: 'geo_zone_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'geo_zone_name',
      title: 'Наименование геозоны',
      type: 'text',
      required: true,
    },
    {
      name: 'geo_zone_category',
      title: 'Категория',
      type: 'list',
      required: false,
      values: [
        { key: 'Разрешённая', value: 'Разрешённая' },
        { key: 'Запрещённая', value: 'Запрещённая' },
      ]
    },
    {
      name: 'violation_weight',
      title: 'Вес (оценка) нарушения геозоны',
      type: 'number',
      required: false,
      minValue: 0,
      maxValue: 10
    },
    {
      name: 'geo_zone_zone',
      title: 'Полигон геозоны',
      type: 'polygon',
      required: true,
      isPolygon: true,
      disableFilter: true,
      disableSort: true,
    },
  ],
  newTemplate: {
    geo_zone_id: null,
    geo_zone_name: null,
    geo_zone_zone: null,
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'geo_zone_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'geo_zone_id',
        field: 'geo_zone_id',
      },{
        title: 'geo_zone_name',
        field: 'geo_zone_name',
      },
      {
        title: 'geo_zone_zone',
        field: 'geo_zone_zone',
      },
    ],
    example: `1;1;null`,
  },
};

export default config;
